/**
 * Модуль для загрузки и инициализации данных боя
 * Вынесено из legacy-app.js для модульности
 */

/**
 * Загружает данные боя и инициализирует состояние
 * @param {object} battleData - Данные боя с полями battle и summary
 * @param {object} battleState - Объект состояния боя (w)
 * @param {function} buildBattlePanels - Функция построения панелей боя
 * @param {function} buildBattleTimeline - Функция построения timeline
 * @param {function} buildStatusTimeline - Функция построения timeline статусов (ds)
 * @param {function} processTelemetryByRound - Функция обработки телеметрии (cs)
 * @param {function} determineWinnerInfo - Функция определения победителя
 * @param {function} getBattleWinner - Функция получения победителя из battle
 * @param {function} resetBattleState - Функция сброса состояния (Jt)
 * @param {function} clearBattleTimers - Функция очистки таймеров (Me)
 * @param {function} clearPlaybackTimer - Функция очистки таймера воспроизведения (ue)
 * @param {function} hideWinnerBanner - Функция скрытия баннера победителя (Be)
 * @param {function} renderBattle - Функция рендеринга боя (fe)
 * @param {object} playerPreview - Превью игрока (J)
 * @param {object} enemyPreview - Превью врага (X)
 */
export function loadBattleData(
  battleData,
  battleState,
  {
    buildBattlePanels,
    buildBattleTimeline,
    buildStatusTimeline,
    processTelemetryByRound,
    determineWinnerInfo,
    getBattleWinner,
    resetBattleState,
    clearBattleTimers,
    clearPlaybackTimer,
    hideWinnerBanner,
    renderBattle,
    playerPreview,
    enemyPreview
  }
) {
  const battle = battleData?.battle;
  
  if (!battle) {
    resetBattleState();
    return;
  }
  
  // Очищаем таймеры и баннер
  clearPlaybackTimer();
  clearBattleTimers();
  
  const summary = battleData?.summary || {};
  
  // Строим панели и timeline
  const panels = buildBattlePanels(battle, { 
    playerPreview, 
    enemyPreview 
  });
  const timeline = buildBattleTimeline(battle, panels);
  
  // Обновляем состояние боя
  battleState.battle = battle;
  battleState.panels = panels;
  battleState.timeline = timeline;
  battleState.statusTimeline = buildStatusTimeline(battle, timeline);
  battleState.telemetryByRound = processTelemetryByRound(battle, panels);
  battleState.currentStep = 0;
  battleState.isPlaying = false;
  battleState.lastRenderedStep = -1;
  battleState.summary = summary;
  battleState.winner = determineWinnerInfo(battle, panels, timeline, summary, getBattleWinner);
  
  // Скрываем баннер и рендерим бой
  hideWinnerBanner();
  renderBattle();
}











